/* Automatisations du parcours — RJ-06 (Bible §28.1 · MER-84).
   Per-Stage reminders with approved delays, local windows, frequency caps and
   class/consent checks. Retries are idempotent and reported separately: a
   delivery failure never changes progression, and never changes the gift. */
import { useState } from 'react'
import { ListRow, Note, Switch } from '@/ui'
import { Retour } from './parts'

const AUTOS = [
  { id: 'deblocage', label: 'Rappel de déblocage', meta: '« Votre prochaine expérience est disponible » · le jour J, 10:00 locales', on: true },
  { id: 'expiration', label: 'Rappel d’expiration du cadeau', meta: '14 jours avant (verrouillé par défaut)', on: true },
  { id: 'utile', label: 'Relance visite utile', meta: 'réservation/itinéraire · +7 jours · max 1 par étape', on: false },
]

export default function Automatisations() {
  const [etats, setEtats] = useState<Record<string, boolean>>(
    Object.fromEntries(AUTOS.map(a => [a.id, a.on])))

  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 780 }}>
      <Retour />
      <h2 className="t-page" style={{ margin: 0 }}>Automatisations du parcours</h2>

      <section>
        {AUTOS.map(a => (
          <ListRow key={a.id} title={a.label} meta={a.meta}
            end={<Switch checked={etats[a.id]} aria-label={a.label}
              onChange={e => setEtats(s => ({ ...s, [a.id]: e.currentTarget.checked }))} />} />
        ))}
      </section>

      <Note tone="candour">
        Sorties automatiques&nbsp;: cadeau utilisé, étape suivante émise, campagne terminée,
        préférence retirée. Un échec d’envoi ne change jamais la progression ni le cadeau.
      </Note>
    </div>
  )
}
